import { IntervalCondition } from "../IntervalCondition";
import { PeriodConditionsTypeEnum } from "../types";

export class TimeInterval extends IntervalCondition {
  type: PeriodConditionsTypeEnum = PeriodConditionsTypeEnum.TimeInterval;
}
